module.exports = __webpack_public_path__ + "img/step3_online.b77bee66.png";